import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
/**
 * Hook to access the AuthContext
 * Returns the full auth context including userProfile, user, and authentication methods
 * @returns {AuthContextType} The auth context
 */
export function useAuthContext() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within an AuthProvider');
    }
    return context;
}
